export const columns = function() {
  return [
    {
      prop: 'username',
      label: '客户名称',
      minWidth: 50
    },
	{
	  prop: 'tel',
	  label: '客户电话',
	  minWidth: 50
	},
	{
	  prop: 'idCard',
	  label: '身份证号',
	  minWidth: 50
	},
	{
	  prop: 'address',
	  label: '地址',
	  minWidth: 50
	},
	{
	  prop: 'carNo',
	  label: '车牌号',
	  minWidth: 50
	},
	{
	  prop: 'vin',
	  label: '车架号',
	  minWidth: 50
	},
	{
	  prop: 'engine',
	  label: '发动机号',
	  minWidth: 50
	},
	{
	  prop: 'nature',
	  label: '车辆性质',
	  minWidth: 50
	},
	{
	  prop: 'model',
	  label: '车型',
	  minWidth: 50
	},
	{
	  prop: 'carBeginDate',
	  label: '初登日期',
	  minWidth: 50
	},
	{
	    prop: 'handle',
	    label: '操作',
	    width: 150,
	    fixed: 'right'
	}
  ]
} 


export default {}